// extracted by mini-css-extract-plugin
export var container = "_gi-0";
export var content = "_gi-3";
export var customerTitle = "_gi-4";
export var empty = "_gi-5";
export var gray = "_gi-6";
export var header = "_gi-7";
export var info = "_gi-8";
export var loading = "_gi-2";
export var loadingCard = "_gi-9";
export var oneLine = "_gi-a";
export var personName = "_gi-e";
export var pillContainer = "_gi-b";
export var selected = "_gi-1";
export var text = "_gi-c";
export var twoLines = "_gi-d";
export var unread = "_gi-f";
export var unreadIndicator = "_gi-g";